import { useEffect, useRef } from 'react';
import useInitializeSelectedUTC from '@alltrails/conditions/hooks/useInitializeSelectedUTC';
import { millisecondsInMinute } from '@alltrails/data-formatting/dateConstants';
import { useAppDispatch, useAppSelector } from '@/utils/redux';
import { setConditionsPanelOpen } from '@/utils/slices/exploreSlice';

export const exploreConditionsIntervalMin = 30;
export const exploreConditionsIntervalMs = exploreConditionsIntervalMin * millisecondsInMinute;

const useExploreConditions = () => {
  const dispatch = useAppDispatch();
  const { activeCondition, trailId } = useAppSelector(state => ({
    activeCondition: state.conditions.activeCondition,
    trailId: state.explore.currentTrail?.id
  }));
  const isConditionActive = Boolean(activeCondition);

  useInitializeSelectedUTC(exploreConditionsIntervalMs);

  // Mounted once (via ExploreMap in the root layout) so the panel state has a single writer.
  const previous = useRef({ isConditionActive, trailId });
  useEffect(() => {
    const { isConditionActive: wasConditionActive, trailId: previousTrailId } = previous.current;
    previous.current = { isConditionActive, trailId };

    const isSameTrail = trailId === previousTrailId;

    if (isConditionActive && !wasConditionActive && isSameTrail && trailId !== undefined) {
      // Activated while already on this trail — the user asked for it, so take over the sidebar.
      dispatch(setConditionsPanelOpen(true));
    } else if (!isConditionActive || !isSameTrail) {
      // Cleared, or arrived at a trail with an overlay carried over from elsewhere.
      dispatch(setConditionsPanelOpen(false));
    }
    // Anything else (e.g. swapping between conditions on the same trail) leaves the panel as it is.
  }, [dispatch, isConditionActive, trailId]);
};

export default useExploreConditions;
